module.exports = __webpack_public_path__ + "static/img/icc_new.70ac3e26.png";